const CameraManager = {
  current: null,
};

export { CameraManager };
